import { render, staticRenderFns } from "./DonutChartPanel.vue?vue&type=template&id=e7e7569e&scoped=true&"
import script from "./DonutChartPanel.vue?vue&type=script&lang=js&"
export * from "./DonutChartPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e7569e",
  null
  
)

export default component.exports